/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HeaderSubSection } from 'src/components/ZillowNavbar/page-frame-types/HeaderSubSection';
import { HomeLoansDashboardLink } from 'src/components/ZillowNavbar/components/HomeLoansDashboardLink';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { MobileDropdownMenuMegaMenuContainer } from './components/MobileDropdownMenuMegaMenuContainer';
import { MobileDropdownMenuSubSectionList } from './components/MobileDropdownMenuSubSectionList';
import { MobileDropdownMenuSubSection } from './components/MobileDropdownMenuSubSection';
import { MobileDropdownMenuSubSectionContainer } from './components/MobileDropdownMenuSubSection/components/MobileDropdownMenuSubSectionContainer';

export type MobileDropdownMenuMegaMenuProps = {
    subsections: HeaderSubSection[];
    zhlHost: string;
    isHomeLoansDashboardLinkRendered: boolean;
    version: HEADER_VERSIONS;
};

export const MobileDropdownMenuMegaMenu: FunctionComponent<MobileDropdownMenuMegaMenuProps> = ({
    subsections,
    zhlHost,
    isHomeLoansDashboardLinkRendered,
    version,
    ...rest
}) => (
    <MobileDropdownMenuMegaMenuContainer {...rest}>
        <MobileDropdownMenuSubSectionList>
            {isHomeLoansDashboardLinkRendered && (
                <MobileDropdownMenuSubSectionContainer>
                    <HomeLoansDashboardLink version={version} zhlHost={zhlHost} />
                </MobileDropdownMenuSubSectionContainer>
            )}
            {subsections.map((subsection, index) => (
                <MobileDropdownMenuSubSection subsection={subsection} key={`${subsection.title}-${index}`} />
            ))}
        </MobileDropdownMenuSubSectionList>
    </MobileDropdownMenuMegaMenuContainer>
);
